import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  Button,
  ButtonGroup,
  Form,
  CustomInput,
  FormGroup,
  Row, Label,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle, DropdownItem, Input
} from 'reactstrap';
import ReactHtmlParser from 'react-html-parser';
import { Colxx, Separator } from '../../../../../components/common/CustomBootstrap';
import Switch from 'rc-switch';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { htmlEditButton } from 'quill-html-edit-button';

Quill.register('modules/htmlEditButton', htmlEditButton);

let arr = [];
const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image'],
    ['clean'],
  ],
  htmlEditButton: {},
};

const quillFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',

];

function EmbedBulkPurchase({
  integration,
  integrationProperties,
  allProperties,
  saveIntegration,
  locale,
  pageSettings
}) {  
  const [selectedItem, setSelectedItem] = useState('Voucher Email');
  const [setting, setSetting] = useState(pageSettings);
  const [formatedProperties, setFormatedProperties] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState('');  
  const [isCustom, setIsCoustom] = useState(pageSettings.bulkPurchase !== undefined ? pageSettings.bulkPurchase.isEnabled : false);
 

  const handleSwitchChange = (value) => {
    setIsCoustom(value);
  };


  const handleSave = () => {
    setting.bulkPurchase = {isEnabled: isCustom ? true : false};    
    saveIntegration({ pageSettings: setting});
    arr = [];  
    setIsEditing(!isEditing);
  };


  const Show = () => {
    return (
      <CardBody>
        <div className='text-center mb-0'>
           <h3>Bulk Purchase</h3>
        </div>     
        <div className='d-flex justify-content-center my-3'>
                <CustomInput
                  key="isFooterAiva"
                  type="checkbox"
                  checked={isCustom}
                  onChange={(e) => handleSwitchChange(e.target.checked)}
            ><span>Purchase vouchers in bulk and have them sent to a list of recipients</span></CustomInput>
        </div>
        <div className='text-center'>
          <ButtonGroup className="mb-2 text-center" style={{ marginTop: '20px' }}>
            <Button color="primary" size="xs" onClick={handleSave}>
              Save
            </Button>
            <Button
              size="xs"
              color="dark"
              outline
              onClick={() => setIsEditing(!isEditing)}
            >
              Cancel
            </Button>
          </ButtonGroup>
        </div>
      </CardBody>


    );
  };


  return <Card className="mb-4">{Show()}</Card>;
}

const mapStateToProps = ({ settings }) => {
  const { locale } = settings;
  return {
    locale
  };
};

export default injectIntl(connect(mapStateToProps, {})(EmbedBulkPurchase));